<template>
  <div class="content">
    <BlockUI
      v-if="this.blockScreen"
      :url="blockScreenData.url"
      :message="blockScreenData.msg"
    />
    <v-card>
      <v-card-title>
        Indicações
      </v-card-title>

      <v-card-subtitle>
        <v-flex class="mt-2">
          <v-row>
            <v-flex xs12 md3 sm6>
              <v-col align="start">
                <v-dialog
                  ref="dialog_begin"
                  v-model="modal_begin"
                  :return-value.sync="begin_date"
                  persistent
                  max-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="begin_date"
                      label="Data inicio"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>

                  <v-date-picker
                    v-model="begin_date"
                    scrollable
                    class="color"
                    :header-color="header_color"
                  >
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="modal_begin = false"
                      >Cancelar</v-btn
                    >
                    <v-btn
                      flat
                      color="primary"
                      @click="$refs.dialog_begin.save(begin_date)"
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-dialog>
              </v-col>
            </v-flex>

            <v-flex xs12 md3 sm6>
              <v-col align="start">
                <v-dialog
                  ref="dialog_end"
                  v-model="modal_end"
                  :return-value.sync="end_date"
                  persistent
                  max-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="end_date"
                      label="Data fim"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>

                  <v-date-picker
                    v-model="end_date"
                    scrollable
                    :header-color="header_color"
                  >
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="modal_end = false"
                      >Cancel</v-btn
                    >
                    <v-btn
                      flat
                      color="primary"
                      @click="$refs.dialog_end.save(end_date)"
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-dialog>
              </v-col>
            </v-flex>

            <v-flex xs12 md3 sm6>
              <v-col align="start">
                <v-btn
                  block
                  color="info"
                  class="mt-3 white--text"
                  @click="filtrar()"
                  >Filtrar</v-btn
                >
              </v-col>
            </v-flex>

            <v-flex xs12 md3 sm6>
              <v-col align="center">
                <download-excel
                  :data="indicationData"
                  :fields="json_fields"
                  name="indicacoes.xls"
                >
                  <v-btn
                    :disabled="indicationData.length > 0 ? false : true"
                    block
                    color="success"
                    class="mt-3 white--text"
                  >
                    Exportar
                    <v-icon right>mdi-file-excel</v-icon>
                  </v-btn>
                </download-excel>
              </v-col>
            </v-flex>
          </v-row>
        </v-flex>
      </v-card-subtitle>

      <v-card-text>
        <v-row class="mb-5">
          <v-flex xs12 md6 sm6>
            <v-col align="start">
              <v-text-field
                v-model="approver"
                prepend-icon="search"
                label="Procurar"
                single-line
                hide-details
              />
            </v-col>
          </v-flex>
        </v-row>

        <v-row class="ma-6">
          <v-flex class="col">
            <v-data-table
              no-data-text="nenhuma reserva registrada"
              :headers="headers"
              :items="indicationData"
              :search="approver"
              item-key="name"
              group-key="name"
              class="elevation-1 mt-2"
            >
              <template v-slot:item="{ item }">
                <tr>
                  <td class>{{ item.name }}</td>
                  <td class>
                    {{ item.created_at ? formatDate(item.created_at) : '-' }}
                  </td>
                  <td class>{{ item.approved ? 'Sim' : 'Não' }}</td>
                  <td class>{{ item.confirmed_sms ? 'Sim' : 'Não' }}</td>
                  <td class>{{ item.invitation_code }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import moment from 'moment';
import { blockScreenUi } from '../../helpers/BlockScreenUi';
import UserController from '../../controllers/UserController.js';

export default {
  data() {
    return {
      blockScreenData: blockScreenUi.blockScreenData,
      blockScreen: false,
      header_color: 'blue',
      begin_date: moment()
        .startOf('months')
        .add(-1, 'months')
        .format('YYYY-MM-DD'),
      end_date: moment()
        .endOf('months')
        .add(-1, 'months')
        .format('YYYY-MM-DD'),
      modal_begin: false,
      modal_end: false,
      typeClient: null,
      approver: '',
      json_fields: {
        Nome: 'name',
        Cadastro: {
          field: 'created_at',
          callback: value => this.formatDate(value),
        },
        'Aprovado?': {
          field: 'approved',
          callback: value => (value ? 'Sim' : 'Não'),
        },
        'Confirmado?': {
          field: 'confirmed_sms',
          callback: value => (value ? 'Sim' : 'Não'),
        },
        'Indicado por': 'invitation_code',
      },
      indicationData: [],
      headers: [
        { text: 'Nome', value: 'name' },
        { text: 'Cadastro', value: 'created_at' },
        { text: 'Aprovado?', value: 'approved' },
        { text: 'Confirmado?', value: 'confirmed_sms' },
        { text: 'Indicado por', value: 'invitation_code', sortable: false },
      ],
    };
  },
  created() {
    this.userController = new UserController(this.$resource);
    this.loadData(this.begin_date, this.end_date);
  },
  methods: {
    formatDate(date) {
      return moment(date).format('DD[/]MM[/]YYYY HH:mm');
    },

    filtrar() {
      this.loadData(this.begin_date, this.end_date);
    },

    async loadData(begin_date = null, end_date = null) {
      this.blockScreen = true;
      try {
        const response = await this.userController.getIndicationReport(
          begin_date,
          end_date
        );

        this.indicationData = response.data;
      } catch (error) {
        this.$awn.alert('Erro ao buscar relatório de indicações.');
      } finally {
        this.blockScreen = false;
      }
    },
  },
};
</script>

<style lang="scss"></style>
